import React from 'react';
import { DownloadSVG } from '../../@common_components/svgs/download.svg';

const DownloadIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <DownloadSVG {...props} />;
};

export { DownloadIcon };
